import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IDataIdentifierSSC } from 'app/shared/model/data-identifier-ssc.model';
import { getEntity, updateEntity, createEntity, reset } from './data-identifier-ssc.reducer';

export const DataIdentifierSSCUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const dataIdentifierSSCEntity = useAppSelector(state => state.dataIdentifierSSC.entity);
  const loading = useAppSelector(state => state.dataIdentifierSSC.loading);
  const updating = useAppSelector(state => state.dataIdentifierSSC.updating);
  const updateSuccess = useAppSelector(state => state.dataIdentifierSSC.updateSuccess);

  const handleClose = () => {
    navigate('/data-identifier-ssc');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    values.createdDate = convertDateTimeToServer(values.createdDate);
    values.lastModifiedDate = convertDateTimeToServer(values.lastModifiedDate);

    const entity = {
      ...dataIdentifierSSCEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          createdDate: displayDefaultDateTime(),
          lastModifiedDate: displayDefaultDateTime(),
        }
      : {
          ...dataIdentifierSSCEntity,
          createdDate: convertDateTimeFromServer(dataIdentifierSSCEntity.createdDate),
          lastModifiedDate: convertDateTimeFromServer(dataIdentifierSSCEntity.lastModifiedDate),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="integrawebApp.dataIdentifierSSC.home.createOrEditLabel" data-cy="DataIdentifierSSCCreateUpdateHeading">
            <Translate contentKey="integrawebApp.dataIdentifierSSC.home.createOrEditLabel">Create or edit a DataIdentifierSSC</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="data-identifier-ssc-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('integrawebApp.dataIdentifierSSC.description')}
                id="data-identifier-ssc-description"
                name="description"
                data-cy="description"
                type="text"
                validate={{
                  maxLength: { value: 80, message: translate('entity.validation.maxlength', { max: 80 }) },
                }}
              />
              <ValidatedField
                label={translate('integrawebApp.dataIdentifierSSC.shortDesc')}
                id="data-identifier-ssc-shortDesc"
                name="shortDesc"
                data-cy="shortDesc"
                type="text"
                validate={{
                  maxLength: { value: 20, message: translate('entity.validation.maxlength', { max: 20 }) },
                }}
              />
              <ValidatedField
                label={translate('integrawebApp.dataIdentifierSSC.shortDescInt')}
                id="data-identifier-ssc-shortDescInt"
                name="shortDescInt"
                data-cy="shortDescInt"
                type="text"
                validate={{
                  maxLength: { value: 20, message: translate('entity.validation.maxlength', { max: 20 }) },
                }}
              />
              <ValidatedField
                label={translate('integrawebApp.dataIdentifierSSC.type')}
                id="data-identifier-ssc-type"
                name="type"
                data-cy="type"
                type="text"
                validate={{
                  maxLength: { value: 1, message: translate('entity.validation.maxlength', { max: 1 }) },
                }}
              />
              <ValidatedField
                label={translate('integrawebApp.dataIdentifierSSC.length')}
                id="data-identifier-ssc-length"
                name="length"
                data-cy="length"
                type="text"
              />
              <ValidatedField
                label={translate('integrawebApp.dataIdentifierSSC.special')}
                id="data-identifier-ssc-special"
                name="special"
                data-cy="special"
                type="text"
              />
              <ValidatedField
                label={translate('integrawebApp.dataIdentifierSSC.createdDate')}
                id="data-identifier-ssc-createdDate"
                name="createdDate"
                data-cy="createdDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('integrawebApp.dataIdentifierSSC.createdBy')}
                id="data-identifier-ssc-createdBy"
                name="createdBy"
                data-cy="createdBy"
                type="text"
                validate={{
                  maxLength: { value: 4, message: translate('entity.validation.maxlength', { max: 4 }) },
                }}
              />
              <ValidatedField
                label={translate('integrawebApp.dataIdentifierSSC.lastModifiedDate')}
                id="data-identifier-ssc-lastModifiedDate"
                name="lastModifiedDate"
                data-cy="lastModifiedDate"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('integrawebApp.dataIdentifierSSC.lastModifiedBy')}
                id="data-identifier-ssc-lastModifiedBy"
                name="lastModifiedBy"
                data-cy="lastModifiedBy"
                type="text"
                validate={{
                  maxLength: { value: 4, message: translate('entity.validation.maxlength', { max: 4 }) },
                }}
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/data-identifier-ssc" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default DataIdentifierSSCUpdate;
